import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'antd';

import { actions } from "store";
import { Page, PageHeader } from 'components/layout';
import { CountryList, CountryForm } from 'components/blocks/geo';


class CountryListScreen extends Component {
    showEditForm = (item = null) => {
        const { actions } = this.props;
        actions.geoCountryShowEditForm({ show: true, object: item });
    };

    render() {
        const { history } = this.props;

        return (
            <Page>
                <PageHeader
                    title="Страны"
                    actions={[
                        <Button type="primary" className="" icon="plus" onClick={() => this.showEditForm()}>
                            Добавить страну
                        </Button>
                    ]}
                />

                <div className="page-content page-content-full">
                    <div className="page-block page-block-full">
                        <CountryList basePath="/country" history={history}/>
                    </div>
                </div>

                <CountryForm/>
            </Page>
        );
    }
}


function mapStateToProps(state) {
    return {
        geo_country: state.geo_country,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.geo_country), dispatch),
        dispatch: dispatch
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(CountryListScreen);
